import React from 'react'
import {observer, inject} from 'mobx-react';
import {Button, CircularProgress, Fade, FormControl, Modal, TextField} from "@material-ui/core";
import {AuthButtonsBlock} from './auth_buttons_block';


const AuthModal = inject('authStore')(observer(({authStore}) => {
        authStore.init();
        return (
            <Modal
                open={authStore.modalVisibility}
                onClose={authStore.closeModal}
                closeAfterTransition
                disableBackdropClick={authStore.isAuthPage()}
                className="auth-modal-window"
                BackdropProps={{
                    timeout: 500,
                }}
            >
                <Fade in={authStore.modalVisibility} className="auth-modal-body">
                    <div>
                        {authStore.loading ?
                            <div className="register-loading">
                                <CircularProgress color="secondary" className="loader"/>
                            </div>
                            : ''
                        }
                        <div className="logo">
                            <img alt="logo-booking"
                                 src={(process.env.NODE_ENV === 'development' ? 'http://tonesky.darlane' : '') + '/images/logo_booking_small.png'}/>
                        </div>
                        {authStore.user ?
                            <div>
                                <div className="title-block">
                                    Вы уже авторизованы
                                </div>
                            </div> :
                            authStore.showEmailModal ?
                                <div className="email-block-auth">
                                    <div className="title-block">
                                        Для окончания регистрации добавьте Ваш e-mail
                                    </div>
                                    <FormControl
                                        className="hide-border input-grey flex-full-width"
                                    >
                                        <TextField
                                            placeholder="e-mail"
                                            onChange={authStore.handleChangeEmail}
                                            value={authStore.authData.email}
                                            variant="outlined"
                                        />
                                    </FormControl>
                                    <div className='register-email-error'>{authStore.errorMessage}</div>
                                    <div className="buttons-block">
                                        <Button variant="contained" onClick={authStore.authWithEmail}>
                                            Сохранить
                                        </Button>
                                    </div>
                                </div>
                                :
                                <AuthButtonsBlock authStore={authStore}/>
                        }
                    </div>
                </Fade>
            </Modal>
        );
    }
));

export default AuthModal
